import React, { Component } from 'react';
import './index.scss';
import { Button } from 'react-bootstrap';
import { VictoryLegend, VictoryAxis, VictoryChart, VictoryVoronoiContainer, VictoryGroup, VictoryTooltip, VictoryLine } from "victory";
import service from "../service/api"

class Chart extends Component {
  constructor(props) {
    super(props)
      
    this.state = {
      width : 1000,
      values : [],
      data : [],
    }

  }

  componentDidMount() {
    var values = []
    for (var i in this.props.data) {
      var name = (this.props.data[i].category  in service.match)?service.match[ this.props.data[i].category ]:this.props.data[i].category
      values.push(  { name:  name } )
    }
    this.setState( {
      values : values,
      data : this.props.data,
    } )
    window.onresize = (e) => {
      //var w = window.innerWidth - 300;
      //if( window.innerWidth*0.7 >= 750) {
      //    w = 1000
      //} else if( window.innerWidth*0.7 < 750 ) {
      //    w = 600
      //} else  {
      //    w = 400
      //}
      //if (w) {
      //    _this.setState( { width : w } )
      //}
    }
  }

  //componentWillReceiveProps(props) {  
  componentDidUpdate( props, state ) {
    if( JSON.stringify(this.props.data) !== JSON.stringify(state.data) ) {
      var values = []
      for (var i in this.props.data) {
        var name = (this.props.data[i].category  in service.match)?service.match[ this.props.data[i].category ]:this.props.data[i].category
        values.push(  { name:  name } )
      }
      this.setState( {
        values : values,
        data : props.data,
      } )
    }

  }


  render() {
    if (this.props.data.length > 0) {
      return(
        <div className={["Chart-Holder"].join(' ')} >
          { this.props.selectedSymbol && 
            <div className={["Btn-Holder"].join(' ')}>
              <Button className={["Btn"].join(' ')} onClick={
                (e)=>{
                  var sym = this.props.selectedSymbol.replace( ".HK", "" )
                  sym = parseInt( sym, 10 )
                  window.open( "http://www.aastocks.com/tc/stocks/quote/detailchart.aspx?symbol="+sym,  )
                }
              }>
                  {  "> " +this.props.selectedSymbol  }
              </Button>
              <Button className={["Btn"].join(' ')} onClick={
                (e)=>{
                  var sym = this.props.selectedSymbol.replace( ".HK", "" )
                  var link = window.location.origin + "/?symbol=" + sym
                  const el = document.createElement('textarea');
                  el.value = link;
                  document.body.appendChild(el);
                  el.select();
                  document.execCommand('copy');
                  document.body.removeChild(el);
                  //navigator.clipboard.writeText(copyText.value);
                  alert("Copied : " + link);  

                }
              }>
                  { "Copy link" }
              </Button>
              <iuput type="text" className={["link"].join(' ')} id={"mysrclink"} value={ window.location.origin + "/?symbol=" + this.props.selectedSymbol.replace( ".HK", "" ) }/>
            </div>
          }
            <VictoryChart className={[ "Chart" ].join(' ')} containerComponent={<VictoryVoronoiContainer/>} width={ this.state.width }>
                  
                  <VictoryAxis
                      crossAxis
                      standalone={false}
                      axisValue={100}
                      style={{
                        axis: {stroke: !this.props.selectedSymbol?"#FFFFFF33":"#FFFFFF00" },
                        axisLabel: {fontSize: !this.props.selectedSymbol?12:0, padding: 30, fill : '#FFFFFF99'},
                        tickLabels: {fontSize: !this.props.selectedSymbol?5:0, padding: 5, fill : '#FFFFFF99'}
                      }}
                  />

                  <VictoryAxis
                      crossAxis
                      dependentAxis
                      label={ !this.props.selectedSymbol?service.match[this.props.selectedCategory.category]:this.props.selectedSymbol }
                      invertAxis={ (this.state.type==="rank") }
                      style={{
                        axis: { stroke: "#FFFFFF33" },
                        axisLabel: {fontSize: 12, padding: 30, fill : '#FFFFFF99'},
                        tickLabels: {fontSize: 8, padding: 5, fill : '#FFFFFF99'}
                      }}
                  />
                  
                  <VictoryLegend x={50} y={10}
                      orientation="horizontal"
                      gutter={20}
                      itemsPerRow={6}
                      style={{ 
                          labels: {
                              fontSize:10, 
                              padding: 5,
                              fill : '#FFFFFF99'
                              /*opacity: ((!this.props.selectedCategory)?1:0.5)) ,*/
                          }
                      }}
                      colorScale={"qualitative"}
                      data={this.state.values}
                      events={[{
                          target: "labels",
                          eventHandlers: {
                            onClick: (e) => {
                              if( !this.props.selectedSymbol ) {
                                for (var i in this.props.rank) {
                                  if(  service.match[this.props.rank[i].category] === e.target.innerHTML  ) {
                                    this.props.updateValue( {
                                      selectedCategory : this.props.rank[i]
                                    })
                                    break
                                  }
                                }
                              }
                            }
                          }
                      }]}
                  />
                  
                  <VictoryGroup colorScale={"qualitative"}>
                      { this.state.data.map( (v,k) => { 
                          return(
                                  <VictoryLine 
                                      style={{
                                      data: {
                                              strokeWidth:  (!this.props.selectedSymbol?(  (this.props.selectedCategory.category === v.category  )?5:1   ):2) ,
                                              opacity:      (!this.props.selectedSymbol?(  (this.props.selectedCategory.category === v.category  )?1:0.4):1)  ,
                                              zIndex :      (!this.props.selectedSymbol?(  (this.props.selectedCategory.category === v.category  )?10:5):10)
                                          }
                                      }}
                                      key={k}
                                      name={v.category}
                                      labels={({ datum }) => "["+( (v.category in service.match)?service.match[v.category]:v.category )+`] : ${ Math.round(datum.y*100)/100 }` + "(" + datum.x  + ")" }
                                      labelComponent={
                                          <VictoryTooltip style={{ fontSize: 8 }}/>
                                      }
                                      data={ v.value }
                                      events={[{
                                          target: "parent",
                                          eventHandlers: {
                                            onClick: () => {
                                              //console.log( v.category )
                                              //if( this.props.selectedCategory ===  v.category) {
                                              //    this.props.updateValue( {  selectedCategory : null } )
                                              //} else {
                                              if( !this.props.selectedSymbol ) {
                                                this.props.updateValue( {  selectedCategory : v  } )
                                              }
                                              //}
                                          }
                                        }
                                      }]}
                                      animate={{
                                          duration: 1000,
                                          onLoad: { duration: 500 }
                                      }}/>
                              )
                      })} 
                  </VictoryGroup>
            </VictoryChart>
        </div>
      )
    } else {
      return null
    }
  }
}

export default Chart;

/*

*/